export default "__VITE_ASSET__By$WNP9L__"